(function() { module.exports = this["vendor_backend"]; }());


//////////////////
// WEBPACK FOOTER
// external "vendor_backend"
// module id = 50
// module chunks = 951